import { render, staticRenderFns } from "./feedbackType.vue?vue&type=template&id=ac755758&scoped=true&"
import script from "./feedbackType.vue?vue&type=script&lang=js&"
export * from "./feedbackType.vue?vue&type=script&lang=js&"
import style0 from "./feedbackType.vue?vue&type=style&index=0&id=ac755758&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac755758",
  null
  
)

export default component.exports